import { BigNumber } from "ethers";
import { formatEtherBalance } from "utils/numberUtils";

type EtherAmountProps = {
  amount?: BigNumber;
};

const EtherAmount = ({ amount }: EtherAmountProps) => (
  <>{amount ? formatEtherBalance(amount) : "–"}</>
);

export default EtherAmount;
